import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from '../../pipes/pipes.module';
import { ProcessConfigurationModule } from '../process-configuration/process-configuration.module';
import { ProcessConfigModalComponent } from 'src/app/shared/components/process-config-modal/process-config-modal.component';

@NgModule({
    declarations: [
        ProcessConfigModalComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        PipesModule,
        ProcessConfigurationModule
    ],
    exports: [ProcessConfigModalComponent]
})
export class ProcessConfigModalModule {
}
